module.exports = __webpack_public_path__ + "img/mcbalogo1.5643ae2b.jpg";